export default __webpack_public_path__ + "media/images/svg/li_icon-5ff75a51037e08bc0b03a9172882d0f6.svg";